import { Button, Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import "./confirm-public.modal.scss";
import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, TextField, Typography } from "@mui/material";
import { ProfileResumeModel } from "../models/profile-resume.model";
import { useEffect, useState } from "react";
import { trackEvent } from "../utils/trackGA4.util";
import { GAConfig } from "../utils/ga-config.util";
import UtilityService from "../utils/ga4.util";
interface ConfirmInfoProps {
    isOpen: boolean,
    onClose: () => void
    dataField: ProfileResumeModel
    onConfirmData: (data: ProfileResumeModel) => void

}

const ConfirmInfoModal: React.FC<ConfirmInfoProps> = ({ isOpen, onClose, dataField, onConfirmData }) => {
    const [formData, setFormData] = useState({
        email: '',
        first_name: '',
        last_name: '',
        latest_job_title: '',
        phone: '',
    });

    const [consent, setConsent] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorLastName, setErrorLastName] = useState(false);
    const [errorJobTitle, setErrorJobTitle] = useState(false);

    useEffect(() => {
        if (dataField) {
            setFormData({
                email: dataField.email == null ? "" : dataField.email,
                first_name: dataField.first_name == null ? "" : dataField.first_name,
                last_name: dataField.last_name== null ? "" : dataField.last_name,
                latest_job_title: dataField.latest_job_title == null ? "" : dataField.latest_job_title,
                phone: validateAndFormatThaiPhoneInit(dataField.phone ?? ""),
            });
        }
    }, [dataField])
    const validateAndFormatThaiPhoneInit = (input: string): string => {
        if (!input) return "";
        // Step 1: Remove special characters like spaces, dashes, parentheses, dots
        let cleaned = input.replace(/[\s\-().]/g, "");
        // Step 2: Convert +66 to 0
        if (cleaned.startsWith("+66")) {
          cleaned = "0" + cleaned.slice(3);
        }
        // Step 3: Validate Thai mobile and landline formats
        const isMobile = /^0[689]\d{8}$/.test(cleaned);
        const isLandline = /^0\d{8}$/.test(cleaned);
      
        return isMobile || isLandline ? cleaned : input;
      };
      
      
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.name === "email") {
            setErrorEmail(false);
        }
        if (e.target.name === "phone") {
            setErrorPhone(false);
        }
        if (e.target.name === "first_name") {
            setErrorName(false);
        }
        if (e.target.name === "last_name") {
            setErrorLastName(false);
        }
        if (e.target.name === "latest_job_title") {
            setErrorJobTitle(false);
        }
        if (e.target.name === "consent") {
            setConsent(e.target.checked);
        }

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const rawInput = e.target.value;
        const formatted = validateAndFormatThaiPhone(rawInput);
      
        // Set to formatted only if valid, otherwise keep raw input
        setFormData(prev => ({
          ...prev,
          phone: formatted !== null ? formatted : rawInput,
        }));
      };
    const handleSubmit = () => {
        if (!consent || !formData.email || !formData.first_name || !formData.last_name 
            || !formData.latest_job_title || !formData.phone 
            ) {
            if (!consent) {
                alert("กรุณายอมรับนโยบายความเป็นส่วนตัว (Please accept the privacy policy)");
            }

            if (!formData.first_name) {
                setErrorName(true);
            }
            if (!formData.last_name) {
                setErrorLastName(true);
            }
            if (!formData.latest_job_title) {
                setErrorJobTitle(true);
            }
            if (!formData.phone) {
                setErrorPhone(true);
            }

            if (!formData.email) {
                setErrorEmail(true);
            }
           
        } else {
            if (!/\S+@\S+\.\S+/.test(formData.email)) {
                setErrorEmail(true);
            }
            else{
                const formatted = validateAndFormatThaiPhone(formData.phone);
                if (formatted) {
                      trackEvent(GAConfig.action.confirmData, UtilityService());
                    onConfirmData(formData);
                    onClose();
                  console.log("✅ Valid Thai phone:", formatted);
                } else {
                    setErrorPhone(true);
                  console.warn("❌ Invalid phone number format");
                }
               
            }
          
        }



    };
   function validateAndFormatThaiPhone(input: string): string | null {
        // Remove all non-digit characters (like spaces, hyphens, etc.)
        const cleaned = input.replace(/\D/g, "");
      
        // ✅ Check for valid Thai mobile number (starts with 06, 08, or 09 and has 10 digits)
        const isMobile = /^0[689]\d{8}$/.test(cleaned);
      
        // ✅ Check for valid Thai landline (e.g., 02, 053, 074) and 9 digits total
        const isLandline = /^0\d{8}$/.test(cleaned);
      
        if (isMobile || isLandline) {
          return cleaned; // return the cleaned, valid format
        }
        
        return null; // invalid format
      }
    return (
        <>
            <Modal centered show={isOpen} onHide={onClose}>
                <Modal.Body className="confirmControl">
                    <div className="bodyControl">
                        <Box sx={{ maxWidth: 500, mx: 'auto', mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Typography className="title">ยืนยันข้อมูลผู้สมัคร</Typography>
                            <FormControl
                                className={errorEmail ? "formInputError" : "formInput"}
                                fullWidth>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="อีเมล"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl
                                className={errorName ? "formInputError" : "formInput"}
                                fullWidth>
                                <TextField
                                    label="ชื่อ"
                                    name="first_name"
                                    variant="outlined"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl
                                className={errorLastName ? "formInputError" : "formInput"}
                                fullWidth>
                                <TextField
                                    label="นามสกุล"
                                    name="last_name"
                                    variant="outlined"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl
                                className={errorJobTitle ? "formInputError" : "formInput"}
                                fullWidth>
                                <TextField
                                    label="ตำแหน่งล่าสุด"
                                    variant="outlined"
                                    name="latest_job_title"
                                    value={formData.latest_job_title}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl
                                className={errorPhone ? "formInputError" : "formInput"}
                                fullWidth>
                                <TextField
                                    label="เบอร์โทร"
                                    name="phone"
                                    aria-label="phone"
                                    variant="outlined"
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                />
                            </FormControl>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={consent}
                                        onChange={(e) => setConsent(e.target.checked)}
                                    />
                                }
                                label={<span className={"pdpaText"}>เมื่อกดปุ่ม 'ยืนยันข้อมูล' ถือว่าฉันได้อ่านและยอมรับ <a href="https://scoutout.co/terms-th/" target="_blank" className="link">ข้อกําหนด/เงื่อนไขการใช้งาน</a>และ <a href="https://scoutout.co/privacy-th/" target="_blank" className="link">นโยบายความเป็นส่วนตัว</a></span>}
                            />

                            <Button className="buttonSubmit" onClick={handleSubmit}>
                                ยืนยันข้อมูล
                            </Button>
                        </Box>
                    </div>
                </Modal.Body>

            </Modal>

        </>
    )
}

export default ConfirmInfoModal;